import { Family, FamilyMembersNewAddress, IFamilyMembersService } from '../@posturinn/client-react';
import { MobizHttpApiErrorResponse } from '../@posturinn/common-react/core';
import {
	GET_FAMILY_MEMBERS_ERROR,
	GET_FAMILY_MEMBERS_PENDING,
	GET_FAMILY_MEMBERS_SUCCESS,
	UPDATE_FAMILY_MEMBERS_ADDRESS_ERROR,
	UPDATE_FAMILY_MEMBERS_ADDRESS_PENDING,
	UPDATE_FAMILY_MEMBERS_ADDRESS_SUCCESS
} from '../constants/actions/familyMembersActions';
import store from '../store';

export const getFamilyMembers = () => {
	return async function (dispatch) {
		const { injector } = store.getState().mobizReducer;
		const familyMembersService: IFamilyMembersService = injector.get(IFamilyMembersService);
		dispatch({ type: GET_FAMILY_MEMBERS_PENDING });
		familyMembersService.getFamilyMembers().subscribe({
			next: (family: Family) => {
				dispatch({ type: GET_FAMILY_MEMBERS_SUCCESS, payload: family });
			},
			error: (error: MobizHttpApiErrorResponse): void => {
				dispatch({ type: GET_FAMILY_MEMBERS_ERROR, payload: error });
			},
		});
	};
};

export const updateFamilyMembersAddress = (familyMembersNewAddress: FamilyMembersNewAddress) => {
	return async function (dispatch) {
		const { injector } = store.getState().mobizReducer;
		const familyMembersService: IFamilyMembersService = injector.get(IFamilyMembersService);
		dispatch({ type: UPDATE_FAMILY_MEMBERS_ADDRESS_PENDING });
		familyMembersService.updateFamilyMembersAddress(familyMembersNewAddress).subscribe({
			next: () => {
				dispatch({ type: UPDATE_FAMILY_MEMBERS_ADDRESS_SUCCESS });
			},
			error: (error: MobizHttpApiErrorResponse): void => {
				dispatch({ type: UPDATE_FAMILY_MEMBERS_ADDRESS_ERROR, payload: error });
			},
		});
	};
};
